import { LanguageHolder } from "@tlc/ls2pac/components/Language";
import { TLCEventManager } from "../../../../js/lib/events/EventManager";
import { TLCLogger } from "../../../../js/lib/logger";
import { TLCRest } from "../../../../js/lib/rest/REST";
import { LS2PAC_CONSTANTS } from "../../../../js/main/constants";


export const LanguageClientManager = (function ($) {

	var language = {};
	var availableLanguageCache = null;

	const getAvailableLanguagesEvent = LS2PAC_CONSTANTS.Events.onGetAvailableLanguages;
	const getLanguageEvent = LS2PAC_CONSTANTS.Events.onGetLanguage;

	TLCEventManager.addListener(getLanguageEvent, function () {
		onGetLanguage(false);
	});

	TLCEventManager.addListener(LS2PAC_CONSTANTS.Events.onSetLanguage, function () {
		onGetLanguage(true);
	});

	TLCEventManager.addListener(LS2PAC_CONSTANTS.Events.onLogoutResponse, function (event) {
		if(event.success) {
			onGetLanguage(false);
		}
	});

	var onGetLanguage = async function (updateUI) {
		let success = false;
		try {
			const {dictionary} = await LanguageHolder.fetchLanguage();
			language = dictionary;
			TLCLogger.log("language", language);
			success = true;
		}
		catch(e){
			success = false;
		}
		finally {
			TLCEventManager.fireEvent(LS2PAC_CONSTANTS.Events.onGetLanguageResponse, {success:success, data:language, updateUI});
		}
	};

	TLCEventManager.addListener(getAvailableLanguagesEvent, function () {
		onGetAvailableLanguages();
	});

	var onGetAvailableLanguages = function () {
		var success = false,
			languages;

		if (!availableLanguageCache) {
			TLCRest.jsonCall(LS2PAC_CONSTANTS.restUrls.availableLanguages, {
				callback:	  function (data) {
					success = true;
					availableLanguageCache = languages = data.availableLanguages;
					TLCLogger.log("languages", languages);
				},
				finallyHandler:function () {
					TLCEventManager.fireEvent(LS2PAC_CONSTANTS.Events.onGetAvailableLanguagesResponse, {success:success, languages:languages});
				},
				timeout:	   10000
			});
		} else {
			TLCEventManager.fireEvent(LS2PAC_CONSTANTS.Events.onGetAvailableLanguagesResponse, {success:true, languages:availableLanguageCache});
		}
	};

	return {
		getLanguage:function () {
			return language;
		},
		getAvailableLanguagesEvent: getAvailableLanguagesEvent,
		getLanguageEvent: getLanguageEvent
	};

})(jQuery);
